import React from 'react';

const VerGraf1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  const a011505 = autorizacUA.findIndex( autorizac => autorizac === "011505" );
  const a011510 = autorizacUA.findIndex( autorizac => autorizac === "011510" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a011505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a011510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerGraf1
